export interface BudgetTier {
  id: number;
  name: string;
  leadsPerDay: string;
  icon: 'target' | 'trending-up' | 'zap';
  multiplier: number;
  calculateBudget: (floorPrice: number) => number;
}

const roundUpToNearest10 = (value: number): number => {
  return Math.ceil(value / 10) * 10;
};

export const BUDGET_TIERS: BudgetTier[] = [
  {
    id: 1,
    name: 'Test the Waters',
    leadsPerDay: '~1',
    icon: 'target',
    multiplier: 1.1,
    calculateBudget: (floor: number) => roundUpToNearest10(floor * 1.1),
  },
  {
    id: 2,
    name: 'Steady Flow',
    leadsPerDay: '~3',
    icon: 'trending-up',
    multiplier: 3.3,
    calculateBudget: (floor: number) => roundUpToNearest10(floor * 3 * 1.1),
  },
  {
    id: 3,
    name: 'High Volume',
    leadsPerDay: '8+',
    icon: 'zap',
    multiplier: 8.8,
    calculateBudget: (floor: number) => roundUpToNearest10(floor * 8 * 1.1),
  },
];

export const getFloorPriceForClaimType = (
  campaignObjective: { claim_type: string; floor_price: string }[],
  claimType: string,
): number => {
  const match = campaignObjective.find((obj) => obj.claim_type === claimType);
  const parsed = match ? parseFloat(match.floor_price) : NaN;
  return isNaN(parsed) || parsed <= 0 ? 50 : parsed;
};

export const calculateProjectedImpact = (dailyBudget: number, floorPrice: number) => {
  const safeBudget = Math.max(dailyBudget, 0);
  const safeFloor = Math.max(floorPrice, 1);
  const dailyLeads = Math.floor(safeBudget / safeFloor);
  const monthlyLeads = dailyLeads * 30;
  return { dailyLeads, monthlyLeads };
};
